import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ name: 'AnnotationBadges' })
export default class default_1 extends Vue {
    @Prop({ required: true })
    badges;
}
